<!-- 
    가장 최근의 SnapshotData를 기준으로 Type별 Status의 현황을 보여주는 그래프

 -->

 <template>
    <b-row class="w-100 d-flex justify-content-center align-items-center flex-nowrap" :class="isFlexible ? 'h-100' : 'h-80'" style="margin: 0;">
        <loading :active="loading"
             :is-full-page="false"/>
        <div v-if="thereIsNoData" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
        
        <div class="change-yesterday-graph h-100" style="flex:3; position: relative;" :style="isFlexible ? 'padding: 20px 0;' : 'padding: 0;'">
            <apexchart v-if="series && !thereIsNoData" id="chart"
            width="100%" height="100%" ref="apexchart" 
            :options="chartOptions"
                :series="series" />
        </div>

        <div v-if="isFlexible && tableData" class="d-flex align-items-center justify-content-center flex-column h-100" style="flex:1">
            <ChartTable :tableData="tableData"/>
        </div>
    </b-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import ChartTable from "./ChartTable.vue";
import {getHistoryGroupByStatus, formatingDateLabel} from '@/components/chatter/util/graphUtils';
export default {
    name: 'ChangedYesterdayGraph',
    props: [
        'dashboardData',
        'filters',
        'isFlexible'
    ],
    components: {
        apexchart: VueApexCharts,
        ChartTable
    },
    mounted() {
        // this.setSeries();
        // this.setLabels();
        
        let todayDate = new Date(this.today);
        let yesterdayDate = new Date(todayDate);

        yesterdayDate.setDate(yesterdayDate.getDate() - 1);

        let dayOfWeek = yesterdayDate.getDay();


        if(dayOfWeek === 0) {   // 일요일인 경우
            yesterdayDate.setDate(yesterdayDate.getDate() - 2);
        } else if(dayOfWeek === 6) {    // 토요일인 경우
            yesterdayDate.setDate(yesterdayDate.getDate() - 1);
        }

        this.yesterdayDate = yesterdayDate;

        // this.chartOptions.title.text = formatingDateLabel(this.yesterdayDate);
        this.historyData = getHistoryGroupByStatus(this.dashboardData.history, yesterdayDate);
        

        if(this.historyData.length <= 0) {
            this.thereIsNoData = true;
        } else {
            this.reloadGraph();
        }
    },

    watch: {
        filters: {
            deep: true,
            immediate: false,

            handler() {
                if(this.isFlexible) {
                    
                    this.series = [];
                    this.chartOptions.labels = [];
                    this.reloadGraph();
                }
            }
        },
    },
    data() {
        return {
            historyData:'',
            thereIsNoData:false,
            loading : false,
            label : ['To Do', 'In Progress', 'Done+', 'Closed+'],
            currentChatterData : '',
            columnNames: [],
            snapshotData :[],
            series: [],
            tableData: '',
            yesterdayDate: '',
            chartOptions: {
                chart: {
                    // height:'80%',
                    type: "donut",
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: this.isFlexible,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                        csv: {
                            filename: undefined,
                            columnDelimiter: ',',
                            headerCategory: 'category',
                            headerValue: 'value',
                            dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                            }
                        },
                        svg: {
                            filename: undefined,
                        },
                        png: {
                            filename: undefined,
                        }
                        },
                        autoSelected: 'zoom' 
                    },
                },
                title: {
                    text:  '',
                    align: "left",
                    floating: true
                },
                colors: ['#142459', '#176BA0', '#19AADE', '#1AC9E6'],
                // plotOptions: {
                //     bar: { 
                //         columnWidth : '100%',
                //         distributed: true,
                //     }
                // },
                labels : [],
                dataLabels:{
                    enabled:true,
                    formatter: function(value, { seriesIndex, dataPointIndex, w }) {
                        return w.config.series[seriesIndex];
                    }
                },
                plotOptions: {
                    pie: {
                        expandOnClick: false,
                        donut: {
                            size: '60%',
                            labels: {
                                show: this,
                                value: {
                                    show: true,
                                    color: '#2E2E38',
                                    fontSize: this.isFlexible ? '32px' : '20px',
                                    fontWeight: '700',
                                    offsetY: this.isFlexible ? 10 : 0,
                                    formatter: val => this.formatNumber(val, 0)
                                },
                                total: {
                                    show: true,
                                    label: 'Total',
                                    color: '#747480',
                                    fontSize: this.isFlexible ? '18px' : '14px',
                                    formatter: chart => {
                                        const total = chart.config.series.reduce((a, b) => a + b, 0)
                                        return this.formatNumber(total, 0)
                                    }
                                },
                            },
                        },
                    },
                },
                // dataLabels: {
                //     enabled: this.isFlexible, // 데이터 라벨을 사용할 것인지 여부를 설정합니다.
                //     style: {
                //         fontSize: '10px', // 데이터 라벨의 글꼴 크기를 지정합니다.
                //         colors: ['#333'], // 데이터 라벨의 색상을 지정합니다.
                //     },
                //     // offsetX: 10, // 데이터 라벨을 가로 방향으로 이동시킵니다.
                //     offsetY: -9, // 데이터 라벨을 세로 방향으로 이동시킵니다.
                //     formatter: function (val) { // 데이터 라벨의 형식을 설정합니다.
                //         return val;
                //     },
                //     background: { // 데이터 라벨의 배경을 설정합니다.
                //         enabled: true,
                //         foreColor: '#fff',
                //         padding: 4,
                //         borderRadius: 4,
                //         borderWidth: 1,
                //         borderColor: '#ccc',
                //         opacity: 0.8,
                //     }
                // },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val
                        }
                    },
                },
                // stroke: {
                //     width: [4, 4, 4, 4],
                //     curve: 'straight',
                // },
                // xaxis: {
                //     categories: [],
                //     show:this.isFlexible,
                //     labels: {
                //         show:this.isFlexible
                //     }
                // },
                // yaxis: {
                //     labels: {
                //         show:this.isFlexible
                //     }
                // },
                legend: {
                    show: true,
                    position:'bottom',
                    horizontalAlign: "center",
                    fontSize: this.isFlexible ? '14px' : '12px',
                    offsetX: 0,
                    offsetY: this.isFlexible ? 7 : 3,
                },
                grid :{
                    show:false
                }
            },
            statusInfo : {
                'TO_DO' : true, 
                'IN_PROGRESS' : true, 
                'DONE' : true, 
                // 'CANCELLED' : false,
                // 'CONFIRMED' : false,
                // 'APPROVED' : false
            }
        }
    },
    methods: {

        countData(dataArray) {
            
            let toDoCount = 0;
            let inProgressCount = 0;
            let completedCount = 0;
            let closedCount = 0;
            let grandTotalCount = 0;

            // TO_DO 의 creation_date
            // IN_PROGRESS 의 min(updated_date)
            // DONE+ 의 min(updated_date)
            // let todayDate = new Date(this.today);
            // let yesterdayDate = new Date(todayDate);

            // yesterdayDate.setDate(yesterdayDate.getDate() - 1);

            // let dayOfWeek = yesterdayDate.getDay();

            // if(dayOfWeek === 0) {   // 일요일인 경우
            //     yesterdayDate.setDate(yesterdayDate.getDate() - 2);
            // } else if(dayOfWeek === 6) {    // 토요일인 경우
            //     yesterdayDate.setDate(yesterdayDate.getDate() - 1);
            // }

            // 중복제거 로직 하나의 Chatter가 하루에 여러번 상태 변경이 되었을 때 가장 마지막으로 수정된 상태로 카운트
            // 히스토리에서 데이터를 가져올 때 상태별 minUpdatedDate를 가져옴
            // 그 minUpdatedDate 중 가장 최신의 날짜를 가진 
            let lastModifiedChatStatusMap = new Map();

            // 어제 생성, 수정된 데이터 필터링
            for(let i = 0; i<dataArray.length; i++) {
                let data = dataArray[i];

                let creationValid = false;
                let updatedValid = false;

                // 생성 날짜
                let creationDate = new Date(data.date);
                creationValid = creationDate.getTime() === this.yesterdayDate.getTime();
                
                // 수정 날짜
                if(data.updatedDate != '') {
                    let tempDate = new Date(data.updatedDate);
                    let updatedDate = new Date(tempDate.toISOString().slice(0, 10));

                    updatedValid = updatedDate.getTime() === this.yesterdayDate.getTime();
                }
                
                // 어제 생성되거나, 어제 업데이트 되지 않았다면 넘어가기
                if(!creationValid && !updatedValid) {
                    continue;
                }

                // 맵에 있는지 검사
                if(lastModifiedChatStatusMap.has(data.chatId)) {        // 있으면
                    let prevChat = lastModifiedChatStatusMap.get(data.chatId);
                    let lastmodifiedDateStr = prevChat.updatedDate;

                    // 기존 등록된 건이 최초 생성건이라면 업데이트된 것으로 갱신
                    if(lastmodifiedDateStr == '') {
                        lastModifiedChatStatusMap.set(data.chatId, data);
                    } else {    // 기존과 최신 둘 다 업데이트 건이라면 날짜 비교
                        // 기존의 수정날짜와 data의 수정날짜 비교
                        // data의 수정날짜가 크다면 갱신
                        let lastmodifiedDateObj = new Date(lastmodifiedDateStr);
                        let currentModifiedDateObj = new Date(data.updatedDate);

                        if(lastmodifiedDateObj.getTime() < currentModifiedDateObj.getTime()) {
                            lastModifiedChatStatusMap.set(data.chatId, data);
                        }
                    }
                } else {                                                // 없으면
                    // 수정날짜, 상태 추가
                    lastModifiedChatStatusMap.set(data.chatId, data);
                }
            }

            dataArray = Array.from(lastModifiedChatStatusMap.values());
            dataArray.forEach(data => {
                switch (data.status) {
                    case 'TO_DO': toDoCount++; break;
                    case 'IN_PROGRESS': inProgressCount++; break;  
                    case 'DONE':
                    case 'CANCELLED':
                        completedCount++;
                        break;
                    default: closedCount++;
                }  
                grandTotalCount++;
            });

            // 23-09-25 bar -> donut 차트로 변경
            // let series = [{
            //     name : '프로그램 개수',
            //     data : [toDoCount, inProgressCount, completedCount, closedCount]
            // }];

            let series = [toDoCount, inProgressCount, completedCount, closedCount]

            this.tableData = {                 
                "Status": [
                    "To Do",
                    "In Progress",
                    "Done+",
                    "Closed+",
                ],
                "Count": [toDoCount, inProgressCount, completedCount, closedCount],
            }

            return series;
        },

        visualizeGraph() {
            let dataArray = this.historyData;

            if(this.isFlexible) {
                let L1 = this.filters.L1;
                let L2 = this.filters.L2;
                let L3 = this.filters.L3;
                let JOB = this.filters.JOB;
                let PRIORITY = this.filters.PRIORITY;
                let TYPE = this.filters.TYPE;
                let BUSINESS_CATEGORY = this.filters.BUSINESS_CATEGORY;

                // None 값을 ""로 변경
                L1 = L1.map(value => value === "None" ? "" : value);
                L2 = L2.map(value => value === "None" ? "" : value);
                L3 = L3.map(value => value === "None" ? "" : value);
                JOB = JOB.map(value => value === "None" ? "" : value);
                PRIORITY = PRIORITY.map(value => value === "None" ? "" : value);
                TYPE = TYPE.map(value => value === "None" ? "" : value);
                BUSINESS_CATEGORY = BUSINESS_CATEGORY.map(value => value === "None" ? "" : value);

                dataArray = dataArray.filter(item => {

                    return (
                        L1.includes(item.l1) &&
                        L2.includes(item.l2) &&
                        L3.includes(item.l3) &&
                        JOB.includes(item.job) &&
                        PRIORITY.includes(item.priority) &&
                        TYPE.includes(item.type) &&
                        BUSINESS_CATEGORY.includes(item.businessCategory) 
                    );
                });
            }
            
            let series = this.countData(dataArray);

            this.series = series;
            this.setLabels();
        },

        reloadGraph() {
            try {
                this.loading = true;
                this.visualizeGraph();
            } catch(e) {
                this.loading = false;
                this.thereIsNoData = true;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        setLabels() {
            // this.chartOptions.xaxis.categories = this.label;
            this.chartOptions.labels = this.label;
            // 차트를 업데이트
            if (this.$refs.apexchart) {
                this.$refs.apexchart.updateOptions(this.chartOptions);
            }
        },
        setTable() {
            this.tableData = this.data.table;
        },
    },
}
</script>
<style scoped>
.count-label {
    font-size: 2.25rem !important;
    font-weight: 500;
}
.count-data {
    margin-top: 20px;
    font-size: 2.5rem;
    font-weight: 600;
}

.h-80 {
    padding-top: 10px;
    height: 80%;
}
.h-90 {
    height: 90%;
}
</style>
<style>
/* 커스텀 툴팁 스타일 */
.change-yesterday-graph .apexcharts-tooltip {
    border-radius: 100px;
    border: 1px solid #FFF;
    background: transparent;
    color: #FFF;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.20);
}
.change-yesterday-graph .apexcharts-tooltip-series-group.apexcharts-active {
    padding: 0 12px;
}
</style>